module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Синхронизация данных о запросах в СМЭВ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "centered shedule-controls smev-requests-sync-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncInterval),
      expression: "syncInterval"
    }],
    staticClass: "input shedule-input",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.syncInterval)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.syncInterval = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.setSyncInterval,
      "disabled": this.disabled
    }
  }, [_vm._v("\n        " + _vm._s(this.disabled ? 'Идет сохранение...' : 'Сохранить') + "\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left shedule-header"
  }, [_c('h3', {
    staticClass: "shedule-title"
  }, [_vm._v("Интервал синхронизации")]), _vm._v(" "), _c('p', [_vm._v("Значение задается в минутах.")]), _vm._v(" "), _c('p', [_vm._v("При значении "), _c('code', [_vm._v("0")]), _vm._v(" синхронизации не происходит.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-368c27e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Uprid/SmevRequestsSync.vue
// module id = 928
// module chunks = 0